import { DesignTokens, Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  FormattedDate,
  MelcoModelsSerialNumberHistory,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import styled from "styled-components";
import { useLicenseHistory } from "../../hooks/licenses/useLicenseHistory";
import { useEffect } from "react";

const { spacings } = DesignTokens;

const TableWrapper = styled.div`
  margin-left: -${spacings.xlarge}px;
  margin-right: -${spacings.xlarge}px;
`;

type LicensesHistoryListProps = {
  license: MelcoModelsUserSerialNumber | undefined;
};

export const LicensesHistoryList: React.FC<LicensesHistoryListProps> = ({
  license,
}) => {
  const {
    isLoading,
    isFetching,
    data: dataHistory,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    refetch: refetchHistory,
  } = useLicenseHistory(license?.serial_number ?? undefined);

  /**
   *      "history_type": {
              "1": "Created",
              "2": "Registered",
              "3": "Assigned",
              "4": "Removed",
              "5": "Cancelled",
              "6": "Activated",
              "7": "Deactivated",
              "8": "Transferred",
              "9": "Updated",
              "10": "Level changed"
            },
   */
  useEffect(() => {
    refetchHistory();
  }, [license]);
  const { t } = useTranslation();

  const columns = [
    {
      title: t("licenses.basic.detail.history.columns.history_type"),
      key: "history_type",
      dataIndex: "history_type",
      render: (history_type: string) =>
        t(`licenses.basic.detail.history.history_type.${history_type}` as any),
    },

    {
      title: t("licenses.basic.detail.history.columns.user_name"),
      key: "user_name",
      dataIndex: "user_name",
    },
    {
      title: t("licenses.basic.detail.history.columns.computer_name"),
      key: "computer_name",
      dataIndex: "computer_name",
    },
    {
      title: t("licenses.basic.detail.history.columns.operating_system"),
      key: "operating_system",
      dataIndex: "operating_system",
    },
    {
      title: t("licenses.basic.detail.history.columns.version_number"),
      key: "version_number",
      dataIndex: "version_number",
    },
    {
      title: t("licenses.basic.detail.history.columns.created_date"),
      key: "created_date",
      dataIndex: "created_date",
      render: (_: string, item: MelcoModelsSerialNumberHistory) => (
        <FormattedDate date={item.created_date} />
      ),
    },
    {
      title: t("licenses.basic.detail.history.columns.comments"),
      key: "comments",
      dataIndex: "comments",
    },
  ];

  return (
    <TableWrapper>
      <Table
        data-cy-id="license-history"
        showSorterTooltip={false}
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={dataHistory}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={false}
        rowKey="created_date"
        noDataMessage={t("licenses.basic.detail.history.empty")}
        errorComponent={errorComponent}
      />
    </TableWrapper>
  );
};
